"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShowPasswordButton;

var _react = _interopRequireWildcard(require("react"));

var _EyeAlt = _interopRequireDefault(require("@decisiv/iconix/lib/components/EyeAlt"));

var _EyeSlash = _interopRequireDefault(require("@decisiv/iconix/lib/components/EyeSlash"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function ShowPasswordButton(_ref) {
  var showPassword = _ref.showPassword,
      onClick = _ref.onClick,
      disabled = _ref.disabled;
  var translate = (0, _useTranslations.default)();
  var EyeIcon = showPassword ? _EyeSlash.default : _EyeAlt.default;
  var tooltipText = showPassword ? translate(undefined, 'passwordField.hidePassword') : translate(undefined, 'passwordField.showPassword');
  var handleKeyPress = (0, _react.useCallback)(function (event) {
    if (event.key === 'Enter') onClick && onClick(event);
  }, [onClick]);
  return _react.default.createElement(_Tooltip.default, {
    placement: "top",
    target: // eslint-disable-next-line react/jsx-wrap-multilines
    _react.default.createElement(_IconWrapper.default, {
      tabIndex: 0,
      disabled: disabled,
      onKeyPress: handleKeyPress
    }, _react.default.createElement(EyeIcon, {
      onClick: onClick,
      "data-testid": "toggle-password-visible",
      role: "button",
      "aria-expanded": showPassword
    }))
  }, tooltipText);
}